import moment from 'moment'
import request from '@/modules/base/util/request'
import requestConfig from '@/config'
import config from '@/modules/base/components/booking-selection-list/config'

import {
  updateItems,
  listLoading,
  listError,
  LIST_TYPES,
} from '@/redux/ducks/lists'

const { BOOKING_SELECTION_LIST_TYPE } = LIST_TYPES

export const fetchList = (options, excludedBankAccountIds) => {
  return (dispatch) => {
    dispatch(listLoading(BOOKING_SELECTION_LIST_TYPE))
    request(config.urls.fetchTurnoverListForBankAccount(options), { auth: true, isConcurrent: true, timeout: requestConfig.requestExtraLongTimeout })
      .then(response => {
        const {
          body: {
            data: items,
          },
        } = response

        let filteredItems = items

        if (excludedBankAccountIds.length > 0) {
          filteredItems = items.filter(({ bankAccountId }) => !excludedBankAccountIds.includes(bankAccountId))
        }

        const mappedItems = filteredItems.map(item => {
          const { id, bookingDate, bookingContactName, purposeDescription, bookingAmount, ...other } = item

          return {
            id,
            bookingDate: moment(bookingDate),
            bookingContactName,
            purposeDescription,
            bookingAmount,
            ...other,
          }
        })

        dispatch(updateItems(BOOKING_SELECTION_LIST_TYPE, mappedItems))
      })
      .catch((error) => {
        dispatch(listError(error))
      })
  }
}
